export default "__VITE_ASSET__19e9e748__"